import actions from '../actions';
import urls from '../urls';
import constants from '../constants';
import { checkHttpStatus, parseJSON, commonHeaders } from '../utils';

export function getEnterprisesApi(token) {
    const url =`${constants.BASE_API_URL}${urls.ENTERPRISES}`;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "GET",
            headers: Object.assign({}, commonHeaders, {
                'Authorization': 'Bearer ' + token
            })
        })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then((jsonResponse) => {
            resolve(jsonResponse.enterprises);
        })
        .catch(err => {
            console.error("There is an error getting enterprises !!", err);
            reject(err);
        });
    });
}


// WEBPACK FOOTER //
// ./src/apis/enterpriseApis.js